import { render, staticRenderFns } from "./RequisicaoItens.vue?vue&type=template&id=0984639c"
import script from "./RequisicaoItens.vue?vue&type=script&lang=js"
export * from "./RequisicaoItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports